module.exports = __webpack_public_path__ + "img/logo-small.1977255e.png";